import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fetchSocialMediaAPI, updateSocialMediaAPI } from "./socialMediaAPI";
import { showModal } from "../statusModal/statusModal";

const initialState = {
  list: [],
  fetchStatus: "idle",
  error: null,
};

export const fetchSocialMedia = createAsyncThunk(
  "socialMedia/fetchAll",
  async (_, { dispatch, rejectWithValue }) => {
    try {
      const data = await fetchSocialMediaAPI();
      return data;
    } catch (error) {
      dispatch(
        showModal({ message: "فشل في جلب روابط التواصل", status: "error" })
      );
      return rejectWithValue(error.response?.data?.message || "خطأ غير متوقع");
    }
  }
);

export const updateSocialMedia = createAsyncThunk(
  "socialMedia/update",
  async ({ name, data }, { dispatch, rejectWithValue }) => {
    try {
      const updated = await updateSocialMediaAPI({ name, ...data });
      dispatch(showModal({ message: "تم تحديث الرابط", status: "success" }));
      return updated;
    } catch (error) {
      dispatch(showModal({ message: "فشل في التحديث", status: "error" }));
      return rejectWithValue(error.response?.data?.message || "خطأ غير متوقع");
    }
  }
);

const socialMediaSlice = createSlice({
  name: "socialMedia",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchSocialMedia.pending, (state) => {
        state.fetchStatus = "loading";
        state.error = null;
      })
      .addCase(fetchSocialMedia.fulfilled, (state, action) => {
        state.fetchStatus = "succeeded";
        state.list = action.payload;
      })
      .addCase(fetchSocialMedia.rejected, (state, action) => {
        state.fetchStatus = "failed";
        state.error = action.payload;
      })

      .addCase(updateSocialMedia.pending, (state) => {
        state.fetchStatus = "loading";
        state.error = null;
      })
      .addCase(updateSocialMedia.fulfilled, (state, action) => {
        state.fetchStatus = "succeeded";
        const index = state.list.findIndex(
          (item) => item.name === action.payload.name
        );
        // The update creates a platform's row the first time it's saved.
        if (index === -1) state.list.unshift(action.payload);
        else state.list[index] = action.payload;
      })
      .addCase(updateSocialMedia.rejected, (state, action) => {
        state.fetchStatus = "failed";
        state.error = action.payload;
      });
  },
});

export default socialMediaSlice.reducer;
